export const CALDOTCOM_INTEGRATION_GUIDE_URL = 'https://docs.droxy.ai/documentation/integrations/caldotcom';
